// extracted by mini-css-extract-plugin
export var messageSideLeft = "_ju-1";
export var messageSideRight = "_ju-2";
export var subscribeToBackInStockBubbleContainer = "_ju-0";